module.exports = __webpack_public_path__ + "media/application/images/marker-9fedf0f96406a137946862d46236ca0c.png";